const FormLabel = {
  baseStyle: {
    fontFamily: "'Noto Sans JP', sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    color: "#666666",
    mb: "4px",
  },
};
export default FormLabel;
